<div class="timer-button"
     [ngClass]="{'timer-button--state-PAUSE' : currentState == 'PAUSE',
                 'timer-button--state-STOP' : currentState === 'STOP',
                 'timer-button--state-PLAY' : currentState === 'PLAY',
                 'timer-button--clickable' : hasGameController}"
     (click)="stopGameSession()">

  <div class="timer-button__icon timer-button__icon--left" *ngIf="iconRight">
    <brt-icon [icon]="'pause-circle-1'"></brt-icon>
  </div>

  <div class="timer-button__label">{{label}}</div>


</div>
